import { useEffect } from "react";
import PropTypes from "prop-types";
import ProductListingPage from "../../containers/ProductListingPage";
import ProductListSkeleton from "../../components/Results/ProductListSkeleton";
import { withTranslation } from "../../components/translation";
import { useBreadcrumbUpdates } from "../../components/hooks";
import { createSearchBreadcrumbs } from "../../helpers/createSearchBreadcrumbs";
import { mapBreadcrumbs } from "../../state/modules/category/mapBreadcrumbs";
import { useUpdateRefineParameters } from "../hooks/useUpdateRefineParameters";

const SearchPage = ({
  isLoading,
  paginationData: { page },
  formatTranslation,
  searchTerm,
  storeUrl,
  ...rest
}) => {
  if (isLoading) {
    return <ProductListSkeleton />;
  }

  useBreadcrumbUpdates(
    mapBreadcrumbs(
      createSearchBreadcrumbs({
        homeTranslation: formatTranslation("plp_web_breadcrumbs_home"),
        homeLink: storeUrl,
        searchTermTranslation: formatTranslation(
          "plp_web_breadcrumbs_search_results_for"
        ),
        searchTerm
      })
    )
  );

  useUpdateRefineParameters({ searchTerm });

  useEffect(() => {
    if (searchTerm) {
      const { initial, max } = page;

      document.title = formatTranslation("plp_web_search_page_title", {
        searchTerm,
        currentPage: initial,
        maxPage: max
      });
    }
  }, [searchTerm]);

  return <ProductListingPage {...rest} searchTerm={searchTerm} />;
};

SearchPage.propTypes = {
  hasFacets: PropTypes.bool.isRequired,
  itemCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  paginationData: PropTypes.shape({
    page: PropTypes.shape({
      initial: PropTypes.number,
      max: PropTypes.number
    })
  }),
  searchTerm: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  error: PropTypes.object,
  storeUrl: PropTypes.string.isRequired
};

SearchPage.defaultProps = {};

export default withTranslation(SearchPage);
